// src/components/Footer.js
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { joinCommunity } from "../services/community.api";
import {
  FaInstagram,
  FaWhatsapp,
  FaMobileAlt,
  FaEnvelope,
} from "react-icons/fa";

function Footer() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  const phoneDisplay = "79 427 867";
const phoneNumber = "+96179427867";
const emailAddress = "info@chiaca.co";

  const whatsappLink = `https://wa.me/${phoneNumber.replace(/\D/g, "")}`;

  const TEXT = {
    EN: {
      findUs: "FIND US ON",

      information: "Information",
      contactUs: "Contact us",
      aboutUs: "About us",
      terms: "Terms and Conditions",
      privacy: "Privacy Policy",
      paymentDelivery: "Payment and Delivery",
      returns: "Returns",

      myAccount: "My account",
      myOrders: "My orders",
      myAddress: "My address",
      myPersonalInfo: "My personal information",

      storeInfo: "Information about the store",
      callUs: "Call us:",
      officeHours:
        "Customer service office is open from Monday to Friday from 8:00 a.m. to 4:00 p.m",
      emailLabel: "E-mail:",
      locationLabel: "Location:",

      newsletterTitle:
        "Get special discounts, subscribe to the newsletter and CHIACA Club",
      newsletterSubtitle: "Stay up to date with news and promotions",
      emailPlaceholder: "Enter your e-mail address",
      send: "Send",
      sending: "Sending...",
      agreementPrefix:
        "I agree to receive commercial information in the e-mail Newsletter and accept the",
      privacyPolicy: "Privacy Policy.",

      rights: "CHIACA. All rights reserved.",
      success: "Thank you for subscribing!",
      invalid: "Please enter a valid email",
      acceptRequired: "Please accept the privacy policy first.",
      error: "Something went wrong",
    },
    AR: {
      findUs: "تابعونا على",

      information: "معلومات",
      contactUs: "تواصل معنا",
      aboutUs: "من نحن",
      terms: "الشروط والأحكام",
      privacy: "سياسة الخصوصية",
      paymentDelivery: "الدفع والتوصيل",
      returns: "الإرجاع",

      myAccount: "حسابي",
      myOrders: "طلباتي",
      myAddress: "عنواني",
      myPersonalInfo: "معلوماتي الشخصية",

      storeInfo: "معلومات عن المتجر",
      callUs: "اتصل بنا:",
      officeHours:
        "خدمة العملاء متاحة من الاثنين إلى الجمعة من الساعة 8:00 صباحاً حتى 4:00 مساءً",
      emailLabel: "البريد الإلكتروني:",
      locationLabel: "الموقع:",

      newsletterTitle:
        "احصل على خصومات خاصة واشترك في النشرة الإخبارية ونادي CHIACA",
      newsletterSubtitle: "ابقَ على اطلاع بآخر الأخبار والعروض",
      emailPlaceholder: "أدخل بريدك الإلكتروني",
      send: "إرسال",
      sending: "جارٍ الإرسال...",
      agreementPrefix:
        "أوافق على تلقي المعلومات التجارية عبر النشرة البريدية وأقبل",
      privacyPolicy: "سياسة الخصوصية.",
      rights: "CHIACA. جميع الحقوق محفوظة.",
      success: "شكراً لاشتراكك!",
      invalid: "يرجى إدخال بريد إلكتروني صحيح",
      acceptRequired: "يرجى الموافقة على سياسة الخصوصية أولاً.",
      error: "حدث خطأ ما",
    },
  }[lang];

  const navigateToTop = (path) => {
  navigate(path);

  setTimeout(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, 0);
};

  const handleJoin = async () => {
    const isValidEmail = /\S+@\S+\.\S+/.test(email.trim());

if (!isValidEmail) {
  setToast({ type: "error", message: TEXT.invalid });
  return;
}

    if (!accepted) {
      setToast({ type: "error", message: TEXT.acceptRequired });
      return;
    }

    try {
      setLoading(true);
      await joinCommunity(email.trim());
      setEmail("");
      setAccepted(false);
      setToast({ type: "success", message: TEXT.success });
    } catch {
      setToast({ type: "error", message: TEXT.error });
    } finally {
      setLoading(false);
      setTimeout(() => setToast(null), 3000);
    }
  };

  const goAccount = (path) => {
  const token = localStorage.getItem("esill-token");

  if (!token) {
    navigateToTop("/create-account");
    return;
  }

  navigateToTop(path);
};

  const informationLinks = [
  { label: TEXT.contactUs, onClick: () => navigateToTop("/contact") },
  { label: TEXT.aboutUs, onClick: () => navigateToTop("/about") },
  { label: TEXT.terms, onClick: () => navigateToTop("/terms") },
  { label: TEXT.privacy, onClick: () => navigateToTop("/privacy-policy") },
  {
    label: TEXT.paymentDelivery,
    onClick: () => navigateToTop("/payment-delivery"),
  },
  { label: TEXT.returns, onClick: () => navigateToTop("/returns") },
];

  const accountLinks = [
    { label: TEXT.myOrders, onClick: () => goAccount("/orders") },
    { label: TEXT.myAddress, onClick: () => goAccount("/edit-profile") },
    { label: TEXT.myPersonalInfo, onClick: () => goAccount("/edit-profile") },
  ];

  const LinkList = ({ title, items }) => (
    <div className={lang === "AR" ? "text-right" : "text-left"}>
      <h3 className="text-[24px] md:text-[22px] font-bold text-black mb-4">
        {title}
      </h3>

      <div className="space-y-3">
        {items.map((item) => (
          <button
            key={item.label}
            type="button"
            onClick={item.onClick}
            className="
              block
              text-[16px] md:text-[15px]
              text-gray-500
              hover:text-black hover:underline
              transition
            "
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );

  const StoreInfo = () => (
    <div className={lang === "AR" ? "text-right" : "text-left"}>
      <h3 className="text-[24px] md:text-[22px] font-bold text-black mb-5">
        {TEXT.storeInfo}
      </h3>

      <div className="space-y-6">
        <div className="flex items-start gap-4">
          <FaMobileAlt className="text-[34px] text-black mt-1 shrink-0" />

          <div>
            <p className="text-[15px] text-gray-500 mb-1">{TEXT.callUs}</p>

            <a
              href={`tel:${phoneNumber}`}
              className="block text-[20px] font-bold tracking-[0.08em] text-black hover:underline"
            >
              {phoneDisplay}
            </a>

            <p className="text-[15px] text-gray-500 leading-6 mt-2 max-w-[360px]">
              {TEXT.officeHours}
            </p>
          </div>
        </div>

        <a
          href={`mailto:${emailAddress}`}
          className="flex items-center gap-4 text-gray-500 hover:text-black transition"
        >
          <FaEnvelope className="text-[28px] text-black shrink-0" />
          <span className="text-[16px]">
            {TEXT.emailLabel} {emailAddress}
          </span>
        </a>
      </div>
    </div>
  );

  const Newsletter = () => (
    <div className={lang === "AR" ? "text-right" : "text-left"}>
      <h3 className="text-[23px] md:text-[22px] font-bold text-black leading-tight mb-4">
        {TEXT.newsletterTitle}
      </h3>

      <p className="text-[16px] text-gray-700 mb-5">
        {TEXT.newsletterSubtitle}
      </p>

      <div className="flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          placeholder={TEXT.emailPlaceholder}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="
            flex-1
            h-14
            border border-gray-300
            px-3 py-2 md:py-0
            text-[15px]
            outline-none
            focus:border-black
            transition
          "
        />

        <button
          type="button"
          onClick={handleJoin}
          disabled={loading}
          className="
            h-14
            px-8
            bg-black
            text-white
            text-[15px] font-semibold
            hover:bg-gray-900
            disabled:opacity-60
            transition
          "
        >
          {loading ? TEXT.sending : TEXT.send}
        </button>
      </div>

      <label className="mt-5 flex items-start gap-3 text-[14px] leading-6 text-gray-700 cursor-pointer">
        <input
          type="checkbox"
          checked={accepted}
          onChange={(e) => setAccepted(e.target.checked)}
          className="mt-1 w-5 h-5 border border-gray-300 accent-black shrink-0"
        />

        <span>
          {TEXT.agreementPrefix}{" "}
          <button
            type="button"
            onClick={() => navigateToTop("/privacy-policy")}
            className="font-semibold underline text-gray-700 hover:text-black"
          >
            {TEXT.privacyPolicy}
          </button>
        </span>
      </label>
    </div>
  );

  return (
    <footer
      className="w-full bg-[#F6EFE9] mt-1"
      dir={lang === "AR" ? "rtl" : "ltr"}
    >
      <div className="px-6 md:px-10">
        {/* TOP SOCIAL */}
        <div className="border-t border-gray-300 border-b py-5">
          <div className="flex items-center justify-center gap-7">
            <span className="text-[18px] tracking-[0.25em] text-gray-900 uppercase">
              {TEXT.findUs}
            </span>

            <a
              href="https://www.instagram.com/chiaca.lb?stkn=MTJ0dzBvamRrd3ltbg=="
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="text-black hover:opacity-70 transition"
            >
              <FaInstagram className="text-[32px]" />
            </a>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="text-black hover:opacity-70 transition"
            >
              <FaWhatsapp className="text-[31px]" />
            </a>

          </div>
        </div>

        {/* MOBILE */}
        <div className="md:hidden py-8 space-y-12">
          <LinkList title={TEXT.information} items={informationLinks} />
          <LinkList title={TEXT.myAccount} items={accountLinks} />
          <StoreInfo />
          <Newsletter />
        </div>

        {/* DESKTOP */}
        <div className="hidden md:grid grid-cols-[1fr_1fr_1px_1.35fr_1.35fr] gap-10 py-10 max-w-7xl mx-auto">
          <LinkList title={TEXT.information} items={informationLinks} />
          <LinkList title={TEXT.myAccount} items={accountLinks} />

          <div className="w-px bg-gray-300 min-h-[280px]" />

          <StoreInfo />
          <Newsletter />
        </div>
      </div>

      {/* RIGHTS */}
      <div className="w-full bg-black py-7 text-center">
        <p className="text-white text-[15px] tracking-wide">
          {TEXT.rights}
        </p>
      </div>

      {/* TOAST */}
      {toast && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50">
          <div
            className={`
              px-6 py-3 rounded-full text-white font-semibold shadow-xl
              ${toast.type === "success" ? "bg-black" : "bg-red-600"}
            `}
          >
            {toast.message}
          </div>
        </div>
      )}
    </footer>
  );
}

export default Footer;